import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ScaleLoader } from 'react-spinners';

import { sendVerificationCode, verifyEmailByCode } from 'store/actions/auth.action';
import { RootState } from 'store/reducers';
import { closePopup, closeWindows, getLocalStorageValue, handleToast, historyPath, historyPush, localStorageKeyValue, loginSignUpSuccess } from 'utils/handler';
import { NumberInput } from './CommonPages';
import PopupWindow from './Popup';

// let interval: any = null
// let initialTimer = 5
// const EmailVerification: React.FC<{}> = (): JSX.Element => {
//     const [user, setUser] = useState<verifyEmailUserDetail>()
//     const [timer, setTimer] = useState(initialTimer)
//     let history = useHistory()
//     const { t } = useTranslation();

//     useEffect(() => {
//         confirmEmail()
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, [])
//     const confirmEmail = () => {
//         const params = new URLSearchParams(history.location.search);
//         const userUID = params.get('UID')
//         if (userUID) {
//             auth.verifyUser({ userUID }).then(res => {
//                 interval = setInterval(() => {
//                     setTimer(initialTimer - 1)
//                     initialTimer = initialTimer - 1
//                     if (initialTimer <= 0) {
//                         initialTimer = 5
//                         clearInterval(interval)
//                         history.push('/?showLogin=true')
//                     }
//                 }, 1000);
//                 setUser(res)

//             })
//         } else {
//             history.push('/?showLogin=true')
//         }
//     }

//     return <div className="container">
//         <div className="content-body">
//             <div className="verification-email ">
//                 <div className="title">
//                     {t("Email Verification")}
//                 </div>
//                 {user && <div className="form-row  justify-content-center">
//                     <div className="card payment-response fs-25">
//                         <div className=" card-body confirmation-email lh-35">
//                             {/* <span>{t("Hi")} <span className="first-letter-caps"> {user.name}</span>, </span><br /> */}
//                             {/* <span>{t("Thanks for register with us.")}</span><br />
//                             <span>{t("Your Account is successfully verified.")}</span><br />
//                             <span>{t("Login page in")} {timer} {t("seconds")}...</span><br /> */}
//                             <span>{t("Thank you for confirming your email.")}</span><br/>
//                             {t("You will be redirected to the Log In page in")} {timer} {t("seconds")}...
//                         </div>
//                     </div>
//                 </div>}
//             </div>
//         </div>
//     </div>
// }

// export default EmailVerification

const EmailVerification: React.FC<{}> = (): JSX.Element => {
  const { t } = useTranslation();
  const [verificationCode, setVerificationCode] = useState<number>();
  const [showLoading, setShowLoading] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [email, changeEmail] = useState(getLocalStorageValue(localStorageKeyValue.userEmail) || '');
  // const dispatch = useDispatch();
  const { previousAction = '' } = useSelector((state: RootState) => state.mainReducer);
  // const history = useHistory();
  const verifyEmail = (e: React.FormEvent) => {
    e.preventDefault();
    setShowLoading(true);
    if (showEmail && email) {
      sendVerificationMail();
    } else if (verificationCode) {
      verifyEmailByCode({ verificationCode, email }).then((result: any) => {
        if (result)
          loginSignUpSuccess(result, true).then((res) => {
            if (previousAction === '/dashboard') {
              historyPush(historyPath.dashboard);
            }
            closeWindows();
          });
        setShowLoading(false);
      });
    }
  };

  const sendVerificationMail = () => {
    sendVerificationCode(email).then((result) => {
      if (result) {
        handleToast({ message: result }, 'success');
        setShowEmail(false);
      }
    });
  };
  return (
    <>
      <Helmet>
        <title>Email Verify - Saw.com Domain Name Brokerage</title>
      </Helmet>
      <PopupWindow onClose={() => closePopup()} header="Email verification">
        <div className="model m-n3 m-md-0">
          <div className="content form-group">
            <form onSubmit={verifyEmail} className="custom-form">
              {showEmail ? (
                <div className="form-group">
                  <label className="f-bold">Email:</label>
                  <input autoComplete="off" type="email" className={' form-control saw-input '} name="email" value={email} onChange={(e) => changeEmail(e.target.value)} placeholder={t('Enter your Email*')} title="" required />
                  <div className="text-right">
                    <span className="ml-2 hover-u" onClick={() => setShowEmail(false)}>
                      Enter code?
                    </span>
                  </div>
                  <div className="invalid-feedback">{t('Please Enter Valid Email Address')}</div>
                </div>
              ) : (
                <>
                  <div className="form-group">
                    <label className="f-bold">Verification code:</label>
                    <NumberInput id="reUsableCount" placeholder="Enter verification code" name="reUsableCount" value={verificationCode} onChange={(e) => setVerificationCode(Number(e.target.value))} required />
                    <div className="invalid-feedback">{t('Please Enter Valid Email Address')}</div>
                  </div>
                  <div className="mt-3 text-danger fs-13 text-center">
                    Note: The verification code has been sent to your registered E-mail.
                    <span
                      className="ml-1 hover-u text-primary"
                      onClick={() => {
                        email ? sendVerificationMail() : setShowEmail(true);
                      }}
                    >
                      Click here
                    </span>{' '}
                    to resend
                  </div>
                </>
              )}
              <div className="justify-content-center row mt-2">
                <button className="btn-grad btn " disabled={showLoading} onSubmit={verifyEmail}>
                  <span className="ml-2">{showLoading ? <ScaleLoader color={'white'} loading={true} height={20} width={5} radius={3} margin={3} /> : 'Proceed'}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </PopupWindow>
    </>
  );
};

export default EmailVerification;
